import { useState } from 'react';
import { Check, Link } from '@phosphor-icons/react';

export function CopyUrlButton({ url }: { url: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard blocked — surface a toast in a later phase
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-[12px] font-medium text-text-2 transition-colors hover:bg-surface-2 hover:text-text-1"
    >
      {copied ? (
        <>
          <Check size={14} weight="bold" className="text-ok" />
          <span className="text-ok">Copied</span>
        </>
      ) : (
        <>
          <Link size={14} />
          Copy URL
        </>
      )}
    </button>
  );
}
